import { FormRequestParams, FormRequestParamsData } from '../typings/common';

export class FormRequestManager {
    /**
     * Отправка запроса, посредством сабмита формы
     */
    static submit(requestParams: FormRequestParams) {
        const {
            action,
            method = 'POST',
            target = '_self',
            data = {}
        } = requestParams;
        const body = document.body;

        const form = document.createElement('form');
        form.method = method;
        form.action = action;
        form.target = target;
        form.style.display = 'none';

        FormRequestManager.setFormContent(form, data);

        body.appendChild(form);
        form.submit();
        body.removeChild(form);
    }

    /**
     * Устанавливает содержимое формы в соответсвии с параметрами запроса
     */
    private static setFormContent(
        form: HTMLFormElement,
        data: FormRequestParamsData
    ) {
        Object.keys(data).forEach(function(fieldName: string) {
            const origValue = data[fieldName];
            const arrayOfValues: string[] = Array.isArray(origValue)
                ? origValue
                : [origValue];

            arrayOfValues.forEach((fieldValue: string) => {
                const input = document.createElement('input');

                input.name = fieldName;

                input.value = fieldValue;

                input.type = 'hidden';

                form.appendChild(input);
            });
        });
    }
}
